// Currencies where 1 unit >= 50 INR (e.g. GBP, USD, EUR). Use smaller target amount range (1000 - 1,000,000).
export const HIGH_VALUE_CURRENCIES = ["GBP", "USD", "EUR"];

export const countryList = [
    {
        "name": "United Kingdom",
        "countryCode": "GB",
        "flag": "🇬🇧",
        "numberSystem": "Western"
    },
    {
        "name": "United States",
        "countryCode": "US",
        "flag": "🇺🇸",
        "numberSystem": "Western"
    },
    {
        "name": "India",
        "countryCode": "IN",
        "flag": "🇮🇳",
        "numberSystem": "Indian"
    },
    {
        "name": "Spain",
        "countryCode": "ES",
        "flag": "🇪🇸",
        "numberSystem": "Western"
    },
    {
        "name": "France",
        "countryCode": "FR",
        "flag": "🇫🇷",
        "numberSystem": "Western"
    },
    {
        "name": "Japan",
        "countryCode": "JP",
        "flag": "🇯🇵",
        "numberSystem": "Western"
    },
    {
        "name": "Saudi Arabia",
        "countryCode": "SA",
        "flag": "🇸🇦",
        "numberSystem": "Western"
    },
    {
        "name": "Russia",
        "countryCode": "RU",
        "flag": "🇷🇺",
        "numberSystem": "Western"
    },
    {
        "name": "Brazil",
        "countryCode": "BR",
        "flag": "🇧🇷",
        "numberSystem": "Western"
    },
    {
        "name": "Indonesia",
        "countryCode": "ID",
        "flag": "🇮🇩",
        "numberSystem": "Western"
    },
    {
        "name": "Iran",
        "countryCode": "IR",
        "flag": "🇮🇷",
        "numberSystem": "Western"
    },
    {
        "name": "Turkey",
        "countryCode": "TR",
        "flag": "🇹🇷",
        "numberSystem": "Western"
    },
    {
        "name": "South Korea",
        "countryCode": "KR",
        "flag": "🇰🇷",
        "numberSystem": "Western"
    },
    {
        "name": "Germany",
        "countryCode": "DE",
        "flag": "🇩🇪",
        "numberSystem": "Western"
    },
    {
        "name": "Italy",
        "countryCode": "IT",
        "flag": "🇮🇹",
        "numberSystem": "Western"
    },
    {
        "name": "Ukraine",
        "countryCode": "UA",
        "flag": "🇺🇦",
        "numberSystem": "Western"
    },
    {
        "name": "Netherlands",
        "countryCode": "NL",
        "flag": "🇳🇱",
        "numberSystem": "Western"
    },
    {
        "name": "China",
        "countryCode": "CN",
        "flag": "🇨🇳",
        "numberSystem": "Western"
    },
    {
        "name": "Czech Republic",
        "countryCode": "CZ",
        "flag": "🇨🇿",
        "numberSystem": "Western"
    },
    {
        "name": "Pakistan",
        "countryCode": "PK",
        "flag": "🇵🇰",
        "numberSystem": "Indian"
    },
    {
        "name": "Denmark",
        "countryCode": "DK",
        "flag": "🇩🇰",
        "numberSystem": "Western"
    },
    {
        "name": "Philippines",
        "countryCode": "PH",
        "flag": "🇵🇭",
        "numberSystem": "Western"
    },
    {
        "name": "Malaysia",
        "countryCode": "MY",
        "flag": "🇲🇾",
        "numberSystem": "Western"
    },
    {
        "name": "Finland",
        "countryCode": "FI",
        "flag": "🇫🇮",
        "numberSystem": "Western"
    },
    {
        "name": "Vietnam",
        "countryCode": "VN",
        "flag": "🇻🇳",
        "numberSystem": "Western"
    },
    {
        "name": "Thailand",
        "countryCode": "TH",
        "flag": "🇹🇭",
        "numberSystem": "Western"
    }
]

export const languageList = [
    {
        code: "en-GB",
        name: "English",
        language: "(UK)",
        flag: "🇬🇧",
        currency: "£",
        currencyCode: "GBP",
        currencyName: "Pound Sterling",
        countryCode: "GB",
        countryName: "United Kingdom",
        numberSystem: "Western",
    },
    {
        code: "en-US",
        name: "English",
        language: "(US)",
        flag: "🇺🇸",
        currency: "$",
        currencyCode: "USD",
        currencyName: "US Dollar",
        countryCode: "US",
        countryName: "United States",
        numberSystem: "Western",
    },
    {
        code: "en-IN",
        name: "English",
        language: "(India)",
        flag: "🇮🇳",
        currency: "₹",
        currencyCode: "INR",
        currencyName: "Indian Rupee",
        countryCode: "IN",
        countryName: "India",
        numberSystem: "Indian",
    },
    {
        code: "hi",
        name: "Hindi",
        language: "(हिंदी)",
        flag: "🇮🇳",
        currency: "₹",
        currencyCode: "INR",
        currencyName: "Indian Rupee",
        countryCode: "IN",
        countryName: "India",
        numberSystem: "Indian",
    },
    {
        code: "es",
        name: "Spanish",
        language: "(Español)",
        flag: "🇪🇸",
        currency: "€",
        currencyCode: "EUR",
        currencyName: "Euro",
        countryCode: "ES",
        countryName: "Spain",
        numberSystem: "Western",
    },
    {
        code: "fr",
        name: "French",
        language: "(Français)",
        flag: "🇫🇷",
        currency: "€",
        currencyCode: "EUR",
        currencyName: "Euro",
        countryCode: "FR",
        countryName: "France",
        numberSystem: "Western",
    },
    {
        code: "ja",
        name: "Japanese",
        language: "(日本語)",
        flag: "🇯🇵",
        currency: "¥",
        currencyCode: "JPY",
        currencyName: "Japanese Yen",
        countryCode: "JP",
        countryName: "Japan",
        numberSystem: "Western",
    },
    {
        code: "ar",
        name: "Arabic",
        language: "(العربية)",
        flag: "🇸🇦",
        currency: "﷼",
        currencyCode: "SAR",
        currencyName: "Saudi Riyal",
        countryCode: "SA",
        countryName: "Saudi Arabia",
        numberSystem: "Western",
    },
    {
        code: "ru",
        name: "Russian",
        language: "(Русский)",
        flag: "🇷🇺",
        currency: "₽",
        currencyCode: "RUB",
        currencyName: "Russian Ruble",
        countryCode: "RU",
        countryName: "Russia",
        numberSystem: "Western",
    },
    {
        code: "pt",
        name: "Portuguese",
        language: "(Português)",
        flag: "🇧🇷",
        currency: "R$",
        currencyCode: "BRL",
        currencyName: "Brazilian Real",
        countryCode: "BR",
        countryName: "Brazil",
        numberSystem: "Western",
    },
    {
        code: "id",
        name: "Indonesian",
        language: "(Bahasa Indonesia)",
        flag: "🇮🇩",
        currency: "Rp",
        currencyCode: "IDR",
        currencyName: "Indonesian Rupiah",
        countryCode: "ID",
        countryName: "Indonesia",
        numberSystem: "Western",
    },
    {
        code: "fa",
        name: "Persian",
        language: "(فارسی )",
        flag: "🇮🇷",
        currency: "﷼",
        currencyCode: "IRR",
        currencyName: "Iranian Rial",
        countryCode: "IR",
        countryName: "Iran",
        numberSystem: "Western",
    },
    {
        code: "tr",
        name: "Turkish",
        language: "(Türkçe)",
        flag: "🇹🇷",
        currency: "₺",
        currencyCode: "TRY",
        currencyName: "Turkish Lira",
        countryCode: "TR",
        countryName: "Turkey",
        numberSystem: "Western",
    },
    {
        code: "ko",
        name: "Korean",
        language: "(한국어)",
        flag: "🇰🇷",
        currency: "₩",
        currencyCode: "KRW",
        currencyName: "South Korean Won",
        countryCode: "KR",
        countryName: "South Korea",
        numberSystem: "Western",
    },
    {
        code: "de",
        name: "German",
        language: "(Deutsch)",
        flag: "🇩🇪",
        currency: "€",
        currencyCode: "EUR",
        currencyName: "Euro",
        countryCode: "DE",
        countryName: "Germany",
        numberSystem: "Western",
    },
    {
        code: "it",
        name: "Italian",
        language: "(italiano)",
        flag: "🇮🇹",
        currency: "€",
        currencyCode: "EUR",
        currencyName: "Euro",
        countryCode: "IT",
        countryName: "Italy",
        numberSystem: "Western",
    },
    {
        code: "uk",
        name: "Ukrainian",
        language: "(Українська)",
        flag: "🇺🇦",
        currency: "₴",
        currencyCode: "UAH",
        currencyName: "Ukrainian Hryvnia",
        countryCode: "UA",
        countryName: "Ukraine",
        numberSystem: "Western",
    },
    {
        code: "nl",
        name: "Netherlands",
        language: "(Dutch)",
        flag: "🇳🇱",
        currency: "€",
        currencyCode: "EUR",
        currencyName: "Euro",
        countryCode: "NL",
        countryName: "Netherlands",
        numberSystem: "Western",
    },
    {
        code: "zh",
        name: "Chinese",
        language: "(中文)",
        flag: "🇨🇳",
        currency: "¥",
        currencyCode: "CNY",
        currencyName: "Chinese Yuan",
        countryCode: "CN",
        countryName: "China",
        numberSystem: "Western",
    },
    {
        code: "cs",
        name: "Czech",
        language: "(Čeština)",
        flag: "🇨🇿",
        currency: "Kč",
        currencyCode: "CZK",
        currencyName: "Czech Koruna",
        countryCode: "CZ",
        countryName: "Czech Republic",
        numberSystem: "Western",
    },
    {
        code: "ur",
        name: "Urdu",
        language: "(اردو)",
        flag: "🇵🇰",
        currency: "₨",
        currencyCode: "PKR",
        currencyName: "Pakistani Rupee",
        countryCode: "PK",
        countryName: "Pakistan",
        numberSystem: "Indian",
    },
    {
        code: "da",
        name: "Danish",
        language: "(dansk)",
        flag: "🇩🇰",
        currency: "kr",
        currencyCode: "DKK",
        currencyName: "Danish Krone",
        countryCode: "DK",
        countryName: "Denmark",
        numberSystem: "Western",
    },
    {
        code: "tl",
        name: "Filipino",
        language: "(Filipino)",
        flag: "🇵🇭",
        currency: "₱",
        currencyCode: "PHP",
        currencyName: "Philippine Peso",
        countryCode: "PH",
        countryName: "Philippines",
        numberSystem: "Western",
    },
    {
        code: "ms",
        name: "Malay",
        language: "(Bahasa Melayu)",
        flag: "🇲🇾",
        currency: "RM",
        currencyCode: "MYR",
        currencyName: "Malaysian Ringgit",
        countryCode: "MY",
        countryName: "Malaysia",
        numberSystem: "Western",
    },
    {
        code: "fi",
        name: "Finnish",
        language: "(Suomi)",
        flag: "🇫🇮",
        currency: "€",
        currencyCode: "EUR",
        currencyName: "Euro",
        countryCode: "FI",
        countryName: "Finland",
        numberSystem: "Western",
    },
    {
        code: "vi",
        name: "Vietnamese",
        language: "(Tiếng Việt)",
        flag: "🇻🇳",
        currency: "₫",
        currencyCode: "VND",
        currencyName: "Vietnamese Dong",
        countryCode: "VN",
        countryName: "Vietnam",
        numberSystem: "Western",
    },
    {
        code: "th",
        name: "Thai",
        language: "(ไทย)",
        flag: "🇹🇭",
        currency: "฿",
        currencyCode: "THB",
        currencyName: "Thai Baht",
        countryCode: "TH",
        countryName: "Thailand",
        numberSystem: "Western",
    },
];